import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JwtService {
    private _username = '';
    private _password = '';
    constructor(private readonly http: HttpClient) {}

    getToken(): string | undefined {
      const accessToken = window.localStorage.vivent_jwt_token;
      const refreshToken = window.localStorage.vivent_jwt_refresh_token;
      const expireTime = Number(window.localStorage.vivent_jwt_expire);
      const currentTime = new Date().getTime();

      // Check if all required values exist
      if (!accessToken || !refreshToken || !expireTime) {
        return undefined;
      }

      // Check if access token is expired or about to expire (10s buffer)
      if (currentTime > expireTime - 10000) {
        return undefined;
      }

      return accessToken;
    }

    getUserRoleFromStorage(): string {
        if(window.localStorage.userRole === undefined) {
            return undefined;
        }
        return window.localStorage.userRole;
    }

    getCurrentUserClientIdFromStorage(): string {
        if(window.localStorage.ClientId === undefined) {
            return undefined;
        }
        return window.localStorage.ClientId;
    }

    refreshToken(refreshTokenValue: string): Observable<any> {
        const headers = new HttpHeaders({
          'Authorization': `Basic ${environment.clientId}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        });

        const body = new URLSearchParams();
        body.set('grant_type', 'refresh_token'); // standard OAuth 2.0 grant type for refreshing
        body.set('audience', environment.audience);
        body.set('refresh_token', refreshTokenValue); // important: use refresh token here

        return this.http.post(`${environment.auth_url}/token`, body.toString(), { headers });
    }

    setUsername(username: string) {
        this._username = username;
        window.localStorage.vivent_jwt_username = username;
    }

    setPassword(password: string) {
        this._password = password;
    }

    getUsername(): string {
        if(window.localStorage.vivent_jwt_username === undefined) {
            return undefined;
        }
        return window.localStorage.vivent_jwt_username;
    }

    saveToken(token: string,refreshToken:string, exprireDate: number, username: string) {
        window.localStorage.vivent_jwt_token = token;
        window.localStorage.vivent_jwt_refresh_token = refreshToken;
        window.localStorage.vivent_jwt_expire = exprireDate;
        window.localStorage.vivent_jwt_username = username;
    }

    destroyToken() {
        window.localStorage.removeItem('vivent_jwt_token');
        window.localStorage.removeItem('vivent_jwt_expire');
        window.localStorage.removeItem('vivent_jwt_username');
        window.localStorage.removeItem('vivent_jwt_refresh_token');
        window.localStorage.removeItem('userRole');
        window.localStorage.removeItem('ClientId');
        window.localStorage.removeItem('email');
        window.localStorage.removeItem('userId');
    }

    // Fetch new JWT Token
    requestToken(): Observable<any> {
        const headers = new HttpHeaders({
            'Authorization': `Basic ${environment.clientId}`,
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        const body = new URLSearchParams();
        body.set('username', this._username);
        body.set('password', this._password);
        body.set('audience', environment.audience);
        body.set('grant_type', environment.grant_type);

        return this.http.post(`${environment.auth_url}/token`, body.toString(), { headers });

    }

    revokeToken(): Observable<any> {
        const headers = new HttpHeaders({
            'Authorization': `Basic ${environment.clientId}`,
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        const body = new URLSearchParams();
        body.set('refresh_token', window.localStorage.vivent_jwt_refresh_token);

        return this.http.post(`${environment.auth_url}/logout`, body.toString(), { headers });
    }

    get username(): string {
        if (this._username === '') {
            this._username = window.localStorage.vivent_jwt_username;
        }
        return this._username;
      }

    set username(newUsername: string) {
        if (this._username !== newUsername) {
            this._username = newUsername;
            this.destroyToken(); // Clear the token when the username changes
            console.log('Username changed. Token destroyed.');
        }
    }
}
